declare global {
  interface Window {
    fcWidget:any;
    Freshbots:any;
    FreshworksWidget:any
    fwSettings:any
  }
}
export enum ChatBroadcastType {
  Check = 'checkOtherTabs',
  Cancel='cancelWidgetOffload',
  Close ='closeWidget'
}

export interface User{
  id: string,
  name:string,
  email:string,
  phone:string
}

export interface Company{
  id: string,
  name:string,
  email:string,
  created:string,
  status:string,
  activePlan:string,
  stripeId:string,
  relationshipNumber:string,
  prioritySupport:boolean,
  datePurchase:string,
  daySincePurchase:number,
  firstImplementationCallDate:string,
  implementationCSR1:string,
  locationCount:number,
  firstCaptureCallDate:string
}
